// src/pages/gt3x/Overview.jsx

export default function Overview() {
    const everett = { fontFamily: 'Everett, sans-serif' };

    return (
        <>
            {/* Einleitung */}
            <div className="card overview-card-top">
                <h1>GT3 Xperience – Overview</h1>
                <p style={{ marginBottom: "10px",
                    fontFamily: 'var(--ff-Everett), sans-serif',
                }}>
                    Willkommen in unserer iRacing GT3 Xperience! Wir bieten eine strukturierte, faire und moderne
                    Plattform für spannenden GT3-Motorsport.
                </p>
                <p>
                    Schön, dass du dabei bist. Auf dieser Seite findest du
                    die wichtigsten Ansprechpartner sowie den wöchentlichen Ablauf rund um
                    den Renntag.
                </p>
            </div>

            {/* Verantwortliche */}
            <div className="card overview-card">
                <h2>Verantwortliche Personen</h2>

                <div className="fancyTable">
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Bereich</th>
                            <th className="align-left">Verantwortliche</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Ligaverantwortung & Orga</strong></td>
                            <td className="align-left">Patrick Valente Ferro, Robin Fischer, <br/> Michael Kelnberger, Chris Geserer</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Orga</strong></td>
                            <td className="align-left">Nail Hahn, Felix Teichgräber, <br/> Michael Müller, Philipp Gerdellebracht</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Kommunikationsbeauftragter</strong></td>
                            <td className="align-left">Patrick Valente Ferro</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Stream</strong></td>
                            <td className="align-left">Michael Kelnberger</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Decals</strong></td>
                            <td className="align-left">Michael Kelnberger, Felix Teichgräber</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Regelwerk</strong></td>
                            <td className="align-left">Robin Fischer, Chris Geserer</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Reko</strong></td>
                            <td className="align-left">Leitung: Michael Herrmann <br/>
                            Reko Mitglieder: Thomas Kübler, Uwe Länger, <br/>Patrick Vester, Robin Fischer, Chris Geserer</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Designer</strong></td>
                            <td className="align-left">Felix Teichgräber</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Brand Ambassador</strong></td>
                            <td className="align-left">Nail Hahn</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Webseite</strong></td>
                            <td className="align-left">Chris Geserer</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Format */}
            <div className="card overview-card">
                <h2>Liga Format</h2>

                <div className="fancyTable">
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">GT3 Xperience</th>
                            <th className="align-left"></th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Schedule</strong></td>
                            <td className="align-left">iRacing GT-Sprint Serie (12 Weeks) <br/> ggf. IMSA Strecken</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Renndauer</strong></td>
                            <td className="align-left">60 Minuten</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Qualifikation</strong></td>
                            <td className="align-left">Open Qualy</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Wertungen</strong></td>
                            <td className="align-left">PRO, INT, AM, TEAM und inoffizielle Markenwertung</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Streichergebnisse</strong></td>
                            <td className="align-left">Drei</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Tankbegrenzung</strong></td>
                            <td className="align-left">60 %</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Wetter</strong></td>
                            <td className="align-left">Möglichst identisch zu den officals<br/>
                                Ausnahme: Regenrennen - <br/>wenn iRacing eine Chance auf Regen einstellt, <br/>
                                wird es definitiv regnen</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Fahrzeugklasse</strong></td>
                            <td className="align-left">GT3</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Rennkommission</strong></td>
                            <td className="align-left">Es werden möglichst alle Incidents bereits <br/>
                                durch die Orga gesichtet. Die Beurteilung findet dann <br/>
                                durch die ReKo statt. Damit möglichst alle Vorfälle<br/>
                                 auch beurteilt werden und nicht nur eingereichte Proteste.</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Warteliste</strong></td>
                            <td className="align-left">Um über eine ganze Season hinweg ein möglichst <br/>
                                volles Starterfeld zu gewährleisten, führen wir eine <br/>
                                Warteliste und bei Abmeldungen können diese Fahrer <br/>
                                an den entsprechenden Rennen teilnehmen</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Wochenüberblick */}
            <div className="card overview-card">
                <h2>Schedule</h2>

                {/* Sonntag */}
                <h3>Sonntag</h3>
                <div className="fancyTable" style={{ marginBottom: "22px" }}>
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Session</th>
                            <th className="align-left">Zeit</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Trainingsserver</strong></td>
                            <td>~ idR 18:00 – 21:00 Uhr <br/>(siehe Discord Ankündigungen)</td>
                        </tr>
                        <tr>
                            <td className="align-left">Practice</td>
                            <td>2 Std. 30 Min</td>
                        </tr>
                        <tr>
                            <td className="align-left">Qualy</td>
                            <td>15 Min</td>
                        </tr>
                        <tr>
                            <td className="align-left">Race</td>
                            <td>15 Min</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* Montag */}
                <h3>Montag</h3>
                <div className="fancyTable" style={{ marginBottom: "22px" }}>
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Session</th>
                            <th className="align-left">Zeit</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Trainingsserver</strong></td>
                            <td>~ idR 18:00 – 21:00 Uhr <br/>(siehe Discord Ankündigungen)</td>
                        </tr>
                        <tr>
                            <td className="align-left">Practice</td>
                            <td>2 Std. 30 Min</td>
                        </tr>
                        <tr>
                            <td className="align-left">Qualy</td>
                            <td>15 Min</td>
                        </tr>
                        <tr>
                            <td className="align-left">Race</td>
                            <td>15 Min</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* Dienstag */}
                <h3>Dienstag – Renntag</h3>
                <div className="fancyTable" style={{ marginBottom: "22px" }}>
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Session</th>
                            <th className="align-left">Zeit</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Serverstart</strong></td>
                            <td>17:45 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Practice (85 Min)</strong></td>
                            <td>17:45 – 19:10 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Open Qualifying (30 Min)</strong></td>
                            <td>19:10 – 19:40 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Warmup (5 Min)</strong></td>
                            <td>19:40 – 19:45 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Race (60 Min)</strong></td>
                            <td>19:45 – 20:45 Uhr</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* Mittwoch */}
                <h3>Mittwoch</h3>
                <div className="fancyTable">
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Session</th>
                            <th className="align-left">Zeit</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Race Afterview</strong></td>
                            <td>~19:30 Uhr <br/>(siehe Discord Ankündigungen)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
